import { S, P, G } from "./constants";

// ─── Templates ───
export function buildTemplates() {
  const s1 = S("Summary", "High-level business overview");
  s1.pages = [
    P("Summary", [
      G("Subscribers", "line", "subscribers", "total_subs"), 
      G("ARPU", "line", "revenue", "arpu"), 
      G("Revenue", "stacked_bar", "revenue", "revenue_amount")
    ], "3", "bottom"),
    P("Links", [
      G("New Links", "stacked_bar", "subscribers", "gross_new"), 
      G("Terminations", "stacked_bar", "subscribers", "terminations"), 
      G("Net New", "stacked_bar", "subscribers", "net_new")
    ], "3"),
    P("Revenue Breakdown", [
      G("Revenue", "stacked_bar", "revenue", "revenue_amount"), 
      G("New Revenue", "stacked_bar", "revenue", "new_revenue"), 
      G("Term. Revenue", "stacked_bar", "revenue", "termination_revenue"), 
      G("Net New Rev", "stacked_bar", "revenue", "net_new_revenue")
    ], "2", "right"),
  ];

  const s2 = S("Customers Overview", "Top customers analysis");
  s2.pages = [
    P("Revenue by Customer", [G("Revenue", "stacked_bar", "revenue", "revenue_amount", "Top 10 + Others")]),
    P("Revenue % by Customer", [G("Revenue %", "stacked_bar", "revenue", "revenue_pct", "Top 10 + Others")]),
    P("Links by Customer", [G("Links", "stacked_bar", "subscribers", "total_subs", "Top 10 + Others")]),
    P("New Links by Customer", [G("New Links", "stacked_bar", "subscribers", "gross_new", "Top 10 + Others")]),
    P("Termination Links", [G("Terminations", "stacked_bar", "subscribers", "terminations", "Top 10 + Others")]),
  ];

  const s3 = S("Customer Detail", "Per-customer deep dive", "Customer");
  s3.pages = [
    P("Revenue", [
      G("Revenue Total", "stacked_bar", "revenue", "revenue_amount", "Customer & Others"), 
      G("Revenue % vs Others", "stacked_bar", "revenue", "revenue_pct", "Customer & Others")
    ], "2"),
    P("Links", [
      G("Links Total", "stacked_bar", "subscribers", "total_subs", "Customer & Others"), 
      G("Links % vs Others", "stacked_bar", "subscribers", "total_subs", "Customer & Others")
    ], "2"),
    P("Customer Metrics", [
      G("Links", "line", "subscribers", "total_subs", "None", "Customer Only"), 
      G("ARPU", "line", "revenue", "arpu", "None", "Customer Only"), 
      G("Revenue", "line", "revenue", "revenue_amount", "None", "Customer Only")
    ], "3"),
    P("Revenue by Product", [
      G("Rev by Product", "stacked_bar", "revenue", "revenue_amount", "By Product", "Customer Filter → Product Group")
    ]),
    P("Links by Product", [
      G("Links by Product", "stacked_bar", "subscribers", "total_subs", "By Product", "Customer Filter → Product Group")
    ]),
    P("Link Movements", [
      G("New Links", "stacked_bar", "subscribers", "gross_new", "None", "Customer Only"), 
      G("Terminations", "stacked_bar", "subscribers", "terminations", "None", "Customer Only"), 
      G("Net New", "stacked_bar", "subscribers", "net_new", "None", "Customer Only")
    ], "3"),
    P("Revenue Movements", [
      G("New Revenue", "stacked_bar", "revenue", "new_revenue", "None", "Customer Only"), 
      G("Term Revenue", "stacked_bar", "revenue", "termination_revenue", "None", "Customer Only"), 
      G("Net New Rev", "stacked_bar", "revenue", "net_new_revenue", "None", "Customer Only")
    ], "3"),
    P("New Links by Product", [
      G("New Links by Product", "stacked_bar", "subscribers", "gross_new", "By Product", "Customer Filter → Product Group")
    ]),
    P("Term Links by Product", [
      G("Term by Product", "stacked_bar", "subscribers", "terminations", "By Product", "Customer Filter → Product Group")
    ]),
  ];

  // Full report with verticals
  const o = S("Overall", "Business overview", "None", "Business Vertical");
  o.pages = [
    P("Summary", [
      G("Subscribers", "line", "subscribers", "total_subs"), 
      G("ARPU", "line", "revenue", "arpu"), 
      G("Revenue", "stacked_bar", "revenue", "revenue_amount")
    ], "3")
  ];

  const pr = S("Product", "Product lens", "None", "Business Vertical");
  pr.pages = [
    P("Revenue", [G("Revenue", "stacked_bar", "revenue", "revenue_amount", "Top 10 + Others")]),
    P("Revenue %", [G("Revenue %", "stacked_bar", "revenue", "revenue_pct", "Top 10 + Others")]),
    P("Movements", [
      G("New", "stacked_bar", "subscribers", "gross_new", "Top 10 + Others"), 
      G("Net New", "stacked_bar", "subscribers", "net_new", "Top 10 + Others"), 
      G("Terms", "stacked_bar", "subscribers", "terminations", "Top 10 + Others")
    ], "3"),
  ];

  const cu = S("Customer", "Customer lens", "None", "Business Vertical");
  cu.pages = [
    P("Revenue", [G("Revenue", "stacked_bar", "revenue", "revenue_amount", "Top 10 + Others")]),
    P("Revenue %", [G("Revenue %", "stacked_bar", "revenue", "revenue_pct", "Top 10 + Others")]),
    P("Movements", [
      G("New", "stacked_bar", "subscribers", "gross_new", "Top 10 + Others"), 
      G("Net New", "stacked_bar", "subscribers", "net_new", "Top 10 + Others"), 
      G("Terms", "stacked_bar", "subscribers", "terminations", "Top 10 + Others")
    ], "3"),
  ];

  const cd = S("Customer Detail", "Per-customer deep dive", "Customer", "Business Vertical");
  cd.pages = [
    P("Revenue & Share", [
      G("Revenue", "stacked_bar", "revenue", "revenue_amount", "Customer & Others"), 
      G("Revenue %", "stacked_bar", "revenue", "revenue_pct", "Customer & Others")
    ], "2"),
    P("Metrics", [
      G("Links", "line", "subscribers", "total_subs", "None", "Customer Only"), 
      G("ARPU", "line", "revenue", "arpu", "None", "Customer Only"), 
      G("Revenue", "line", "revenue", "revenue_amount", "None", "Customer Only")
    ], "3"),
    P("By Product", [
      G("Rev by Product", "stacked_bar", "revenue", "revenue_amount", "By Product", "Customer Filter → Product Group"), 
      G("Links by Product", "stacked_bar", "subscribers", "total_subs", "By Product", "Customer Filter → Product Group")
    ], "2"),
  ];

  const pd = S("Product Detail", "Per-product deep dive", "Product", "Business Vertical");
  pd.pages = [
    P("Revenue & Share", [
      G("Revenue", "stacked_bar", "revenue", "revenue_amount", "Product & Others"), 
      G("Revenue %", "stacked_bar", "revenue", "revenue_pct", "Product & Others")
    ], "2"),
    P("Movements", [
      G("New", "stacked_bar", "subscribers", "gross_new", "None", "Product Only"), 
      G("Net New", "stacked_bar", "subscribers", "net_new", "None", "Product Only"), 
      G("Terms", "stacked_bar", "subscribers", "terminations", "None", "Product Only")
    ], "3"),
  ];

  return {
    blank: { 
      name: "Blank Report", 
      desc: "Start from scratch", 
      sections: [] 
    },
    standard: { 
      name: "Standard Report", 
      desc: "Summary + Customer Overview + Customer Detail (9 pages)", 
      sections: [s1, s2, s3] 
    },
    withVertical: {
      name: "Full Report (With Verticals)",
      desc: "Includes business vertical additional repeat",
      sections: [o, pr, cu, cd, pd],
    },
  };
}
